import React from 'react'
import { withRouter } from "react-router-dom";
import FormComponent, { FormOp, Validators } from '../../../components/form/FormOps';

class Lugar extends FormComponent {

  static defaultProps = {
    onSave: () => { }
  }

  componentDidMount() {

    this.formConfig(
      { defaultUrl: 'lugar/one', saveUrl: 'lugar/save', backUrl: '/Catalogo/Lugares' },
      FormOp.Group([
        FormOp.Field('text', 'od_lugar', 'Clave', '', [Validators.required], 6),
        FormOp.Field('text', 'od_lugar_nombre', 'Nombre del lugar', '', [Validators.required], 6),
      ], ['Guardar'], 'Lugar'))

    if (this.props.match.params.id)
      this.loadFormPreds(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }

  // state = {
  //   formDefault: null,
  //   form: FormOp.Group([
  //     FormOp.Field('text', 'od_lugar', 'Clave', '', [Validators.required], 6),
  //     FormOp.Field('text', 'od_lugar_nombre', 'Nombre del lugar', '', [Validators.required], 6),
  //   ], ['Guardar'], 'Lugar')
  // }

  // componentDidMount() {
  //   if (this.props.match.params.id)
  //     this.cargarLugar(this.props.match.params.id)
  // }

  // cargarLugar = async (id) => {
  //   let Res = await Http.get(`lugar/${id}`);
  //   if (!Res.error)
  //     this.setState({ formDefault: Res.data })
  // }

  // submit = async (i, vals, load) => {
  //   vals.id = this.props.match.params.id;
  //   var Res = await Http.post('lugar/save', vals);
  //   if (!Res.error) {
  //     load('Guardado', true);
  //     this.props.history.push(`/Catalogos/Lugares`)
  //     this.props.onSave();
  //   } else
  //     load('Error al guardar', false);
  // }

  // render() {
  //   const { params } = this.props.match;

  //   return (
  //     <div>
  //       <div className="form-box">
  //         <Form form={this.state.form} onSubmit={this.submit} default={(!params.id) ? null : this.state.formDefault} />
  //       </div>
  //     </div>
  //   )
  // }
}

export default withRouter(Lugar);
